import { AgentProfileTypeEnum } from '@pages/Admin/Assistants/ui/types';
import { AgentProfileResponseDto } from '@shared/services/apiService';
import i18n from '@shared/utils/i18n';

export const accentOptions = [
  { key: 'rus', value: 'rus', label: 'Russian' },
  { key: 'arb', value: 'arb', label: 'Arabic' },
  { key: 'eng', value: 'eng', label: 'English' },
  { key: 'deu', value: 'deu', label: 'German' },
];

export const mapLanguageToISO639 = (language: string): string => {
  const option = accentOptions.find((opt) => opt.label.toLowerCase() === language?.toLowerCase());

  return option?.value || language;
};

export const DEFAULT_NO_ROLE_AGENT_PROFILE: AgentProfileResponseDto = {
  type: AgentProfileTypeEnum.CUSTOM,
  id: 'id_no_role',
  name: i18n.t('campaignPage.profilePicker.noProfile') as string,
  firstMessageInterruptionsEnabled: false,
};
